export const showChatBoxParamName = 'showChatBox';
